// yapi接口请求域名
export const JAVA_DOMAIN_MAP = {
  mock: 'https://yapi.ppx520.com',
  dev: 'https://testinner-web-gateway.bigo.sg',
  test: 'https://testinner-web-gateway.bigo.sg',
  gray: 'https://gray-web-gateway.bigo.sg',
  prod: 'https://ta.bigolive.tv',
};

// php接口请求域名
export const PHP_DOMAIN_MAP = {
  mock: 'https://yapi.ppx520.com',
  // 测试专区联调环境
  dev: 'https://ta-activity.bigo.tv',
  // 测试专区提测环境
  test: 'https://ta-activity.bigo.tv',
  gray: 'https://bggray-activity.bigo.tv',
  prod: 'https://activity.bigo.tv',
};

// c++接口请求域名
export const CPP_DOMAIN_MAP = {
  mock: 'https://yapi.ppx520.com/mock/8015',
  // 测试专区联调环境
  dev: 'https://livelbs-test-pro.bigo.sg',
  // 测试专区提测环境
  test: 'https://livelbs-test-pro.bigo.sg',
  gray: 'https://gray-https-api.bigolive.tv',
  prod: 'https://https-api.bigolive.tv',
};

// 官网接口请求域名,线上走同域请求
export const BIGOTV_DOMAIN_MAP = {
  mock: 'https://test-inner-web-gateway.bigo.tv',
  // 测试专区联调环境
  dev: 'https://test-inner-web-gateway.bigo.tv',
  // 测试专区提测环境
  test: 'https://test-inner-web-gateway.bigo.tv',
  gray: 'https://gray-web-gateway.bigo.tv',
  prod: 'https://ta.bigo.tv',
};
